import * as React from 'react';

import { FormattedMessage, useIntl } from 'react-intl';
import { Outlet } from 'react-router-dom';

import MainLayout from 'src/components/layout/MainLayout';
import { PERMISSION } from 'src/features/auth/types';
import { PATH } from 'src/features/navigation/utils/constants';
import { pageTitles } from 'src/features/navigation/utils/messages';
import { validationMessages } from 'src/features/validations/utils/messages';
import useHasPermissions from 'src/hooks/useHasPermissions';
import Tab from 'src/registry/components/navigation/Tab';
import TabRow from 'src/registry/components/navigation/TabRow';
import { useTitleStore } from 'src/stores/useTitleStore';

export const ValidationLayout = () => {
    const { formatMessage } = useIntl();

    const accessSearchActiveStaysPermission = useHasPermissions([
        PERMISSION.ACCESS_ACTIVE_STAYS,
        PERMISSION.ALLOW_VALIDATIONS,
    ]);
    const accessValidationsPermission = useHasPermissions([PERMISSION.MANAGE_VALIDATIONS]);

    const { setTitle, removeTitle } = useTitleStore();

    React.useEffect(() => {
        setTitle(formatMessage(pageTitles.validation));
        return removeTitle;
    }, [formatMessage, removeTitle, setTitle]);

    return (
        <MainLayout>
            <TabRow>
                {accessSearchActiveStaysPermission && (
                    <Tab to={`/${PATH.VALIDATIONS}/search`}>
                        <FormattedMessage {...validationMessages.search} />
                    </Tab>
                )}
                {accessValidationsPermission && (
                    <Tab to={`/${PATH.VALIDATIONS}/past-validations`}>
                        <FormattedMessage {...validationMessages.pastValidations} />
                    </Tab>
                )}
            </TabRow>
            <Outlet />
        </MainLayout>
    );
};
